import { Goal, GoalProgress, ProcessedGoalStatus } from './types';

/**
 * Returns individual goal progress for user from user goal data
 *
 * @method prepareGoalProgress
 * @memberof Gamification
 * @param  {Goal} goal - Goal to get progress of
 * @param  {GoalProgress[]} userAchievementGoals - User goal data
 * @returns {ProcessedGoalStatus} - Individual progress
 */

export const prepareGoalProgress = (goal: Goal, userAchievementGoals: GoalProgress[]): ProcessedGoalStatus => {
  const goalIndex = goal.index;

  if (!userAchievementGoals) {
    return { reached: false, text: goal.text };
  }
  for (const goalProgress of userAchievementGoals) {
    if (goalProgress.index === goalIndex) {
      return { reached: goalProgress.reached, text: goal.text };
    }
  }

  return { reached: false, text: goal.text };
};
